"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skipToken = void 0;
var skipToken = exports.skipToken = Symbol.for("apollo.skipToken");